import { z } from 'zod';

export const consentTypeSchema = z.enum(['ocr_processing', 'data_storage', 'analytics']);
export const dsrRequestTypeSchema = z.enum(['access', 'export', 'delete', 'rectify']);
export const dsrRequestStatusSchema = z.enum(['pending', 'processing', 'completed', 'rejected']);
export const legalBasisTypeSchema = z.enum(['consent', 'contract', 'legal_obligation', 'legitimate_interest']);
export const auditActionTypeSchema = z.enum(['create', 'read', 'update', 'delete', 'export', 'process']);
export const actorTypeSchema = z.enum(['user', 'admin', 'system']);
export const subjectTypeSchema = z.enum(['user', 'ocr_request', 'ocr_result']);
export const piiCategorySchema = z.enum(['id_number', 'name', 'address', 'dob', 'expiration', 'metadata']);

export const grantConsentInputSchema = z.object({
  consentType: consentTypeSchema,
  version: z.string().min(1, 'Version is required'),
  acceptedAt: z.string().datetime().optional(),
});

export const requestDataExportInputSchema = z.object({
  format: z.enum(['json', 'csv']).default('json'),
});

export const requestDataDeletionInputSchema = z.object({
  confirmation: z.literal('DELETE_ALL_DATA', {
    errorMap: () => ({ message: 'Must confirm with "DELETE_ALL_DATA"' })
  }),
  reason: z.string().max(500).optional(),
});

export const dsrQuerySchema = z.object({
  type: dsrRequestTypeSchema.optional(),
  status: dsrRequestStatusSchema.optional(),
});

export const auditQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  fromDate: z.string().datetime().optional(),
  toDate: z.string().datetime().optional(),
  actionType: auditActionTypeSchema.optional(),
});

export type RequestDataExportInput = z.infer<typeof requestDataExportInputSchema>;
export type RequestDataDeletionInput = z.infer<typeof requestDataDeletionInputSchema>;
export type DsrQuery = z.infer<typeof dsrQuerySchema>;
export type AuditQuery = z.infer<typeof auditQuerySchema>;
